import { extractProjectFromBrief } from '@wix/ambassador-enterprise-project-v1-project/http';
import { mapProjectToProjectInsight } from './UploadBriefWidget/utils';
import { SortOrder, BrandkitStatus } from '@wix/ambassador-enterprise-brandkit-v1-brandkit/types';
import { queryBrandkits as queryBrandkitsApi } from '@wix/ambassador-enterprise-brandkit-v1-brandkit/http';
export const queryBrandkits = async httpClient => {
  const response = await (httpClient == null ? void 0 : httpClient.request(queryBrandkitsApi({
    query: {
      cursorPaging: {
        limit: 10
      },
      sort: [{
        fieldName: 'updatedDate',
        order: SortOrder.DESC
      }],
      filter: {
        status: BrandkitStatus.PUBLISHED
      }
    }
  })));
  return response == null ? void 0 : response.data.brandkits;
};
export const extractProjectEntityFromBriefApi = async (fileData, briefFileName, httpClient) => {
  if (!httpClient) {
    throw new Error('httpClient is required');
  }
  try {
    const {
      data
    } = await (httpClient == null ? void 0 : httpClient.request(extractProjectFromBrief({
      briefFile: fileData,
      briefFileName
    })));
    const {
      project
    } = data;
    const projectInsight = mapProjectToProjectInsight(project);
    return projectInsight;
  } catch (error) {
    throw error;
  }
};
//# sourceMappingURL=api.js.map